import React, { useCallback } from "react";
import { MapPin } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { StateBadge } from "./AdminLayout";
import { apiGet, apiPost, apiPut } from "./adminApi";

const loadColleges = async () => {
  const list = await apiGet("hec/college/admin/all");
  return list.map((c) => ({
    value: c.id,
    label: `${c.collegeName}${c.institution?.fullName ? ` — ${c.institution.fullName}` : ""}`,
  }));
};

const fields = [
  { name: "collegeId", label: "College", type: "select", required: true, optionsKey: "colleges", optionsLoader: loadColleges, fullWidth: true },
  { name: "campusCode", label: "Campus Code", type: "text", placeholder: "e.g. HUYE" },
  { name: "campusAccronym", label: "Acronym", type: "text", placeholder: "e.g. HYE" },
  { name: "campusName", label: "Campus Name", type: "text", required: true, placeholder: "e.g. Huye Campus", fullWidth: true },
  { name: "active", label: "Status", type: "checkbox", checkboxLabel: "Campus is active", editOnly: true, fullWidth: true },
];

export default function CampusesPage() {
  const toFormValues = useCallback(
    (row) => ({ ...row, collegeId: row.college?.id || "", active: row.state === 1 }),
    []
  );
  return (
    <AdminCrudPage
      title="Campuses"
      subtitle="Physical campuses attached to colleges"
      icon={MapPin}
      entityName="campus"
      queryKey="adminCampuses"
      fetchAll={() => apiGet("hec/bursaryCampus/admin/all")}
      createItem={({ active, ...values }) => apiPost("hec/bursaryCampus/admin/create", values)}
      updateItem={(id, { active, ...values }) => apiPut(`hec/bursaryCampus/admin/${id}`, { ...values, state: active ? 1 : 0 })}
      searchKeys={["campusCode", "campusName", "campusAccronym", "college.collegeName", "college.institution.fullName"]}
      columns={[
        { key: "campusCode", label: "Code", render: (r) => <span className="font-mono text-gray-700">{r.campusCode || "—"}</span> },
        { key: "campusName", label: "Campus", render: (r) => (
            <div>
              <div className="font-semibold text-gray-900">{r.campusName}</div>
              {r.campusAccronym && <div className="text-xs text-gray-400">{r.campusAccronym}</div>}
            </div>
          ) },
        { key: "college.collegeName", label: "College" },
        { key: "college.institution.fullName", label: "Institution" },
        { key: "state", label: "Status", render: (r) => <StateBadge state={r.state} /> },
      ]}
      fields={fields}
      toFormValues={toFormValues}
      filters={[
        { name: "college", label: "Colleges", optionsLoader: loadColleges, match: (row, v) => row.college?.id === v },
      ]}
    />
  );
}
